// extracted by mini-css-extract-plugin
module.exports = {"sysServerHighGrid":"sysServer_sysServerHighGrid__3BfIi","sysServerLowGrid":"sysServer_sysServerLowGrid__TORdR"};